import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import {
  IncreaseProductQuantity,
  DecreaseProductQuantity,
} from '../../store/Slices/gifts/basketSlice';
import Button from '../Button';

import styles from './index.module.scss';

const BasketQuantityWidget = ({ productId, quantity }) => {
  const dispatch = useDispatch();
  const handleQuantityDecrease = (e) => {
    e.preventDefault();

    // Prevent the quantity from decreasing below than "1" with keyboard.
    if (quantity !== 1) {
      dispatch(DecreaseProductQuantity(productId));
    }
  };

  const handleQuantityIncrease = (e) => {
    e.preventDefault();

    dispatch(IncreaseProductQuantity(productId));
  };

  return (
    <div className={styles['basket-quantity-widget']}>
      <Button
        onClick={handleQuantityDecrease}
        className={styles['basket-quantity-widget__btn']}
        isDisabled={quantity === 1}
        data-component={`quantity-decrease${quantity === 1 ? '-disabled' : ''}`}
      >
        –
      </Button>
      <span className="quantity">{quantity}</span>
      <Button
        onClick={handleQuantityIncrease}
        className={styles['basket-quantity-widget__btn']}
        data-component="quantity-increase"
      >
        +
      </Button>
    </div>
  );
};

BasketQuantityWidget.propTypes = {
  productId: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
};

export default connect()(BasketQuantityWidget);
